// extracted by mini-css-extract-plugin
export var modalFooter = "_nf-0";